import * as React from 'react';
import { SVGProps } from 'react';

const SvgDonate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        fill={props.fill}
        d="M10.58 33.43v4.492l17.984.018 4.464-4.473-22.449-.036Z"
      />
      <path
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M13.529 9.764c0 2.49 2.02 4.51 4.51 4.51a4.51 4.51 0 0 0 4.509-4.51V7.51a4.511 4.511 0 0 0-9.02 0v2.254ZM23.64 33.43V23.402l12.211 2.787 1.182-3.102s-1.985-.884-4.537-1.966l-6.277-2.58c-2.147-.839-3.924-1.452-4.483-1.452h-7.07a4.532 4.532 0 0 0-3.383 1.524L0 29.895l2.408 2.652 8.848-7.197v8.09"
      />
      <path
        fill="currentColor"
        d="M29.177 10.72c0-1.497.938-2.705 2.706-2.705 2.706 0 2.706 2.787 2.706 2.787s0-2.787 2.705-2.787C39.062 8.015 40 9.169 40 10.72c0 2.77-4.5 6.54-5.294 7.225a.19.19 0 0 1-.235 0c-.793-.686-5.294-4.456-5.294-7.225Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h40v40H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDonate;
